import {MetaTags} from '@frontend/components/MetaTags'
import {trans} from '@frontend/helpers'
import {useConfigureUi} from '@frontend/hooks/useConfigureUi'
import clsx from 'clsx'
import {Link} from 'react-router-dom'
import {HtmlContent} from 'swayok-react-mdb-ui-kit/components/Typography/HtmlContent'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

interface Props {
    code: 403 | 404 | 500 | 503 | 'js'
    pageTitle?: string
    message?: string
    backUrl?: string
    preferHistoryBack?: boolean
    // Когда true - не отображать кнопку.
    inline?: boolean
    noLogo?: boolean
}

// Страница ошибки.
export default function ErrorPage(props: Props) {

    const {
        code,
        pageTitle,
        message,
        backUrl = '/',
        preferHistoryBack,
        inline,
        noLogo,
    } = props

    // Настройка глобальных элементов интерфейса приложения.
    useConfigureUi(config => (inline ? null : config))

    let errorMessage: {title: string; message: string;}
    switch (code) {
        case 403:
            errorMessage = trans().http_error.code403
            break
        case 500:
            errorMessage = trans().http_error.code500
            break
        case 503:
            errorMessage = trans().http_error.code503
            break
        case 'js':
            errorMessage = trans().http_error.js_error
            break
        case 404:
        default:
            errorMessage = trans().http_error.code404
            break
    }
    if (pageTitle) {
        errorMessage.title = pageTitle
    }
    if (message) {
        errorMessage.message = message
    }

    return (
        <div
            className={clsx(
                'px-4 d-flex align-items-center justify-content-center',
                inline ? 'py-4' : 'full-height px-7'
            )}
            id="error-page"
        >
            <MetaTags
                title={errorMessage.title}
                wrapTitle
            />
            <div className="text-center">
                {!noLogo && (
                    <div className="logo">
                        <img
                            src="/img/dotoku.svg"
                            height="60"
                            alt=""
                        />
                    </div>
                )}
                <HtmlContent
                    block
                    className={clsx(
                        'mt-4',
                        inline ? 'fs-5' : 'fs-3'
                    )}
                    html={errorMessage.message}
                />
                {!inline && (
                    <div className="mt-4">
                        <Link
                            to={backUrl}
                            className="btn btn-gray"
                            onClick={e => {
                                if (preferHistoryBack) {
                                    e.preventDefault()
                                    NavigationService.goBack(backUrl)
                                }
                            }}
                        >
                            {trans().http_error.go_back}
                        </Link>
                    </div>
                )}
            </div>
        </div>
    )
}
